import APIService from "./APIService";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import { useTranslation } from "react-i18next";
import i18n from "i18next";

import ServiceClassPicker from "./ServiceClassPicker";
import TimberMaterialPicker from "./TimberMaterialPicker";
import SteelMaterialPicker from "./SteelMaterialPicker";
import ScrewPicker from "./ScrewPicker";
import CodePicker from "./CodePicker";

export default function GiuntoRipristino(props) {
  const CodeRef = useRef(null);
  const ServiceClassRef = useRef(null);
  const TimberMaterialRef = useRef(null);
  const SteelMaterialRef = useRef(null);
  const ScrewPickerRef = useRef(null);
  const [LoadDuration, SetLoadDuration] = useState("1");
  const [platePosition, SetPlatePosition] = useState("3");
  const [isKmodDisabled, setKmodDisabled] = useState(true);
  const [CreateReport, SetCreateReport] = useState("");
  const [Ratio, setRatio] = useState("");
  const [validData, setValidData] = useState(true);
  const [resultMessages, setResultMessages] = useState("");
  const [maxPlateThk, setMaxPlateThk] = useState(8);
  const [Image, setImage] = useState("Ripristino/Ripristino_1.png");
  const [beamH, setBeamH] = useState(300);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const getRatio = () => {
    const B = parseFloat(getValues("HookB"));
    const H = parseFloat(getValues("HookH"));
    var MaterialName = parseInt(TimberMaterialRef.current.getData());
    const BeamAngle = parseFloat(getValues("HookBeamAngle"));

    var ScrewType = parseInt(ScrewPickerRef.current.getData());
    const TotalX = parseInt(getValues("HookNx"));
    const TotalY = parseInt(getValues("HookNy"));
    const StepsX = parseFloat(getValues("HookStepX"));
    const StepsY = parseFloat(getValues("HookStepY"));
    const X0 = parseFloat(getValues("HookX0"));
    const Y0 = parseFloat(getValues("HookY0"));
    const OffsetY = parseFloat(getValues("HookY"));
    const InvertedDistribution = 0;
    const Predrill = 0;

    var code = parseInt(CodeRef.current.getData());
    const PlateThickness = parseFloat(getValues("HookSp"));
    const PlateL = parseFloat(getValues("HookLp"));
    const PlateH = parseFloat(getValues("HookHp"));
    var PlateConfiguration = parseInt(platePosition);
    var SteelMaterial = parseInt(SteelMaterialRef.current.getData());
    const InternalPlateDistance = parseFloat(getValues("HookDi"));

    var ServiceClass = parseInt(ServiceClassRef.current.getData());
    const language = i18n.language;
    var kmod = parseFloat(getValues("HookKmod"));
    if (isNaN(kmod)) {
      kmod = 0.0;
    }
    const N = parseFloat(getValues("HookNvd"));
    const V = parseFloat(getValues("HookFvd"));
    const M = parseFloat(getValues("HookMvd"));

    const email = JSON.parse(sessionStorage.getItem("email"));
    const address = process.env.REACT_APP_SERVER_URL_COMPLETE_RATIO;

    const promiseResult = APIService.GetRatio(
      {
        B,
        H,
        MaterialName,
        BeamAngle,
        ScrewType,
        TotalX,
        TotalY,
        StepsX,
        StepsY,
        X0,
        Y0,
        OffsetY,
        InvertedDistribution,
        Predrill,
        PlateThickness,
        PlateL,
        PlateH,
        PlateConfiguration,
        SteelMaterial,
        InternalPlateDistance,
        ServiceClass,
        LoadDuration,
        kmod,
        language,
        N,
        V,
        M,
        email,
        code,
      },
      address
    );
    promiseResult.then((value) => {
      console.log(value);
      setRatio(value["ratio"]);
      setResultMessages(value["result"]);
      setValidData(value["valid"]);
    });
  };

  const getReport = () => {
    const B = parseFloat(getValues("HookB"));
    const H = parseFloat(getValues("HookH"));
    var MaterialName = parseInt(TimberMaterialRef.current.getData());
    const BeamAngle = parseFloat(getValues("HookBeamAngle"));

    var ScrewType = parseInt(ScrewPickerRef.current.getData());
    const TotalX = parseInt(getValues("HookNx"));
    const TotalY = parseInt(getValues("HookNy"));
    const StepsX = parseFloat(getValues("HookStepX"));
    const StepsY = parseFloat(getValues("HookStepY"));
    const X0 = parseFloat(getValues("HookX0"));
    const Y0 = parseFloat(getValues("HookY0"));
    const OffsetY = parseFloat(getValues("HookY"));
    const InvertedDistribution = 0;
    const Predrill = 0;

    var code = parseInt(CodeRef.current.getData());
    const PlateThickness = parseFloat(getValues("HookSp"));
    const PlateL = parseFloat(getValues("HookLp"));
    const PlateH = parseFloat(getValues("HookHp"));
    var PlateConfiguration = parseInt(platePosition);
    var SteelMaterial = parseInt(SteelMaterialRef.current.getData());
    const InternalPlateDistance = parseFloat(getValues("HookDi"));

    var ServiceClass = parseInt(ServiceClassRef.current.getData());
    const language = i18n.language;
    var kmod = parseFloat(getValues("HookKmod"));
    if (isNaN(kmod)) {
      kmod = 0.0;
    }
    const N = parseFloat(getValues("HookNvd"));
    const V = parseFloat(getValues("HookFvd"));
    const M = parseFloat(getValues("HookMvd"));

    const email = JSON.parse(sessionStorage.getItem("email"));
    const address = process.env.REACT_APP_SERVER_URL_COMPLETE_REPORT;

    const promiseResult = APIService.GetReportComplete(
      {
        B,
        H,
        MaterialName,
        BeamAngle,
        ScrewType,
        TotalX,
        TotalY,
        StepsX,
        StepsY,
        X0,
        Y0,
        OffsetY,
        InvertedDistribution,
        Predrill,
        PlateThickness,
        PlateL,
        PlateH,
        PlateConfiguration,
        SteelMaterial,
        InternalPlateDistance,
        ServiceClass,
        LoadDuration,
        kmod,
        language,
        N,
        V,
        M,
        email,
        code,
      },
      address
    );
    promiseResult.then((response) => console.log("downloaded")).catch((error) => console.log("error", error));
    setRatio("");
    setResultMessages("");
    setValidData("");
  };

  const onErrors = (errors) => console.error(errors);

  const onSubmit = (event) => {
    if (CreateReport === 0) {
      getRatio();
    } else if (CreateReport === 1) {
      getReport();
    }
  };

  function handleChangeBeamH(e) {
    const currentH = parseFloat(getValues("HookH"));
    setBeamH(currentH);
  }

  const onChangeLoadDuration = (event) => {
    const value = event.target.value;
    SetLoadDuration(value);
    if (value === "0") {
      setKmodDisabled(false);
    } else {
      setKmodDisabled(true);
    }
  };

  const { t } = useTranslation();

  function updateImage(platePosition, screwId){
    if (platePosition === 0) {
      setImage("Ripristino/Ripristino_3.png");
      ScrewPickerRef.current.setValue(300);
    }
    else if (platePosition === 3) {
      if (screwId >= 300 && screwId < 400){
        setImage("Ripristino/Ripristino_1.png");
      }
      else{
        setImage("Ripristino/Ripristino_4.png");
      } 
    } else {
      if (screwId >= 300 && screwId < 400){
        setImage("Ripristino/Ripristino_2.png");
      }
      else{
        setImage("Ripristino/Ripristino_5.png");
      }
    }
  }

  const onChangePosition = (event) => {
    const value = parseInt(event.target.value);
    if (value === 0){
      ScrewPickerRef.current.setNodeId(50);
    }
    else{
      ScrewPickerRef.current.setNodeId(5);
    }
    SetPlatePosition(value);
    var screwType = parseInt(ScrewPickerRef.current.getData());
    updateImage(value, screwType);
    var steelMaterial = parseInt(SteelMaterialRef.current.getData());
    updateMaxPlateThk(screwType, steelMaterial, value)
    console.log(event.target.value);
  };

  const onChangeScrew = (data) => {
    updateImage(parseInt(platePosition), parseInt(data));
  };

  function handleChange(e) {
    const currentB = parseFloat(getValues("HookB"));
    ScrewPickerRef.current.setMaxL(currentB);
  }

  function updateMaxPlateThk(connectorId, steelId, platePosition){
    if (connectorId >= 300 && connectorId < 400){
      if (steelId === 1){
        setMaxPlateThk(10);
      }
      else if (steelId === 2){
        if (platePosition === 3){
          setMaxPlateThk(8);
        }
        else{
          setMaxPlateThk(4);
        }
      }
      else{
        setMaxPlateThk(8);
      }
    }
    else{
      setMaxPlateThk(100);
    }
  }

  const handleEventChangeMaterial = (data) => {
    // Handle the event here with the data from the child
    console.log('Event received from child:', data);
    var connectorId = parseInt(ScrewPickerRef.current.getData());
    var steelMaterial = parseInt(data);
    updateMaxPlateThk(connectorId, steelMaterial, platePosition);
  }

  return (
    <form class="max-w-fit" onSubmit={handleSubmit(onSubmit, onErrors)}>
      <div class="flex flex-wrap -mx-2 mb-5">
        <div class="form-col1_3">
          <TransformWrapper>
            <TransformComponent>
              <img src={Image} alt="" />
            </TransformComponent>
          </TransformWrapper>
        </div>
        <div class="form-col1_3"></div>
        <div class="form-col1_3"></div>

        <div class="form-col1_6">
          <CodePicker ref={CodeRef}></CodePicker>
        </div>
        <ServiceClassPicker ref={ServiceClassRef} />
        <div class="form-col1_6">
          <label class="form-label" for="grid-LoadDuration">
            {t("LoadDuration")}
          </label>
          <select class="form-select" id="grid-LoadDuration" name="grid-LoadDuration" onChange={onChangeLoadDuration} defaultValue={LoadDuration}>
            <option value="1">{t("Permanente")}</option>
            <option value="2">{t("Lunga")}</option>
            <option value="3">{t("Media")}</option>
            <option value="4">{t("Breve")}</option>
            <option value="5">{t("Istantanea")}</option>
            <option value="0">{t("Manual")}</option>
          </select>
        </div>
        {isKmodDisabled ? (
          <div class="form-col1_6" />
        ) : (
          <div class="form-col1_6">
            <label class="form-label" for="grid-kmod">
              {t("Kmod")}
            </label>
            <input
              class="form-input"
              id="grid-kmod"
              type="number"
              step={0.01}
              placeholder={t("Kmod")}
              defaultValue={1}
              readOnly={isKmodDisabled}
              {...register("HookKmod", {
                required: t("Required"),
                min: {
                  value: 0.01,
                  message: t("Minimo") + " 0.01",
                },
                max: {
                  value: 10,
                  message: t("Massimo") + " 10",
                },
              })}
            ></input>
            <p class="form-error">{errors.HookKmod?.message}</p>
          </div>
        )}
        <div class="form-col1_3" />

        <div class="form-col1_6">
          <label class="form-label" for="grid-axial">
            {t("AzioneAssiale")} N<sub>ed</sub> [kN]
          </label>
          <input
            class="form-input"
            id="grid-axial"
            type="number"
            step={0.01}
            defaultValue={10}
            placeholder="Ned [kN]"
            {...register("HookNvd", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p class="form-error">{errors.HookNvd?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-shear">
            {t("Shear")} V<sub>ed</sub> [kN]
          </label>
          <input
            class="form-input"
            id="grid-shear"
            type="number"
            step={0.01}
            defaultValue={5}
            placeholder="Ved [kN]"
            {...register("HookFvd", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p class="form-error">{errors.HookFvd?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-moment">
            {t("Momento")} M<sub>ed</sub> [kNm]
          </label>
          <input
            class="form-input"
            id="grid-moment"
            type="number"
            step={0.01}
            defaultValue={1}
            placeholder="Med [kNm]"
            {...register("HookMvd", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: 100000,
                message: t("Massimo") + " 1.0e6",
              },
            })}
          />
          <p class="form-error">{errors.HookMvd?.message}</p>
        </div>
        <div class="form-col1_6" />
        <div class="form-col1_6" />
        <div class="form-col1_6" />

        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-B">
            {t("BeamBase")}
          </label>
          <input
            class="form-input"
            id="grid-beam-B"
            type="number"
            step={1}
            placeholder="B [mm]"
            defaultValue={200}
            {...register("HookB", {
              required: t("Required"),
              onChange: (e) => {
                handleChange(e);
              },
              min: {
                value: 100,
                message: t("Minimo") + "100mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + "10m",
              },
            })}
          />
          <p class="form-error">{errors.HookB?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-H">
            {t("BeamHeight")}
          </label>
          <input
            class="form-input"
            id="grid-beam-H"
            type="number"
            step={1}
            placeholder="H [mm]"
            defaultValue={300}
            {...register("HookH", {
              required: t("Required"),
              onChange: (e) => {
                handleChangeBeamH(e);
              },
              min: {
                value: 120,
                message: t("Minimo") + "120mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + "10m",
              },
            })}
          />
          <p class="form-error">{errors.HookH?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-beta">
            {t("AngoloTrave")}
          </label>
          <input
            class="form-input"
            id="grid-beam-beta"
            type="number"
            step={0.1}
            placeholder="β [°]"
            defaultValue={160}
            {...register("HookBeamAngle", {
              required: t("Required"),
              min: {
                value: 90,
                message: t("Minimo") + " 90°",
              },
              max: {
                value: 180,
                message: t("Massimo") + " 180°",
              },
            })}
          />
          <p class="form-error">{errors.HookBeamAngle?.message}</p>
        </div>
        <TimberMaterialPicker ref={TimberMaterialRef} />
        <div class="form-col1_6"></div>
        <div class="form-col1_6"></div>

        <SteelMaterialPicker onCustomEvent={handleEventChangeMaterial} maxId={2}  ref={SteelMaterialRef}></SteelMaterialPicker>
        <div class="form-col1_6">
          <label class="form-label" for="grid-Code">
            {t("PosizionePiastra")}
          </label>
          <select class="form-select" id="grid-Code" name="grid-Language" onChange={onChangePosition} defaultValue={3}>
            <option value="3">{t("PiastraCentrale")}</option>
            <option value="4">{t("PiastreCentraleDoppia")}</option>
          </select>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-y">
            {t("PosizioneY")}
          </label>
          <input
            class="form-input"
            id="grid-y"
            type="number"
            step={1}
            defaultValue={0}
            placeholder="Y [mm]"
            {...register("HookY", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0",
              },
              max: {
                value: beamH / 2,
                message: t("Massimo") + " " + beamH / 2 + "mm",
              },
            })}
          />
          <p class="form-error">{errors.HookY?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-Hp">
            {t("AltezzaPiastra")}
          </label>
          <input
            class="form-input"
            id="grid-beam-Hp"
            type="number"
            step={1}
            defaultValue={300}
            placeholder="Hp [mm]"
            {...register("HookHp", {
              required: t("Required"),
              min: {
                value: 100,
                message: t("Minimo") + " 100mm",
              },
              max: {
                value: beamH,
                message: t("Massimo") + " " + beamH + "mm",
              },
            })}
          />
          <p class="form-error">{errors.HookHp?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-Lp">
            {t("LunghezzaPiastra")}
          </label>
          <input
            class="form-input"
            id="grid-beam-Lp"
            type="number"
            step={1}
            defaultValue={400}
            placeholder="Lp [mm]"
            {...register("HookLp", {
              required: t("Required"),
              min: {
                value: 100,
                message: t("Minimo") + " 0mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p class="form-error">{errors.HookLp?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-Sp">
            {t("SpessorePiastra")}
          </label>
          <input
            class="form-input"
            id="grid-beam-Sp"
            type="number"
            step={1}
            defaultValue={8}
            placeholder="Sp [mm]"
            {...register("HookSp", {
              required: t("Required"),
              min: {
                value: 1,
                message: t("Minimo") + " 1mm",
              },
              max: {
                value: maxPlateThk,
                message: t("Massimo") + " " + maxPlateThk,
              },
            })}
          />
          <p class="form-error">{errors.HookSp?.message}</p>
        </div>
        <div class="form-col1_6" hidden={platePosition !== 2}>
          <label class="form-label" for="grid-beam-di">
            Di [mm]
          </label>
          <input
            class="form-input"
            id="grid-beam-Sp"
            type="number"
            step={1}
            defaultValue={100}
            placeholder="Di [mm]"
            {...register("HookDi", {
              required: t("Required"),
              min: {
                value: 1,
                message: t("Minimo") + " 1mm",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000mm",
              },
            })}
          />
          <p class="form-error">{errors.HookDi?.message}</p>
        </div>

        <ScrewPicker onCustomEvent={onChangeScrew} ref={ScrewPickerRef} maxL={200} nodeTypeId={5} eta={true} minL={0} startvalue={306} linkdoc={"SAF.pdf"}/>
        <div class="form-col1_6">
          <label class="form-label" for="grid-Nx">
            {t("ConnectorNx")}
          </label>
          <input
            class="form-input"
            id="grid-Nx"
            type="number"
            step={1}
            defaultValue={6}
            placeholder="Nx"
            {...register("HookNx", {
              required: t("Required"),
              min: {
                value: 2,
                message: t("Minimo") + " 2",
              },
              max: {
                value: 100,
                message: t("Massimo") + " 100",
              },
            })}
          />
          <p class="form-error">{errors.HookNx?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-StepX">
            {t("ConnectorStepxi")}
          </label>
          <input
            class="form-input"
            id="grid-StepX"
            type="number"
            step={1}
            defaultValue={50}
            placeholder="ix [mm]"
            {...register("HookStepX", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0mm",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000mm",
              },
            })}
          />
          <p class="form-error">{errors.HookStepX?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-Ny">
            {t("ConnectorNy")}
          </label>
          <input
            class="form-input"
            id="grid-Ny"
            type="number"
            step={1}
            defaultValue={3}
            placeholder="Ny"
            {...register("HookNy", {
              required: t("Required"),
              min: {
                value: 2,
                message: t("Minimo") + " 2",
              },
              max: {
                value: 100,
                message: t("Massimo") + " 100",
              },
            })}
          />
          <p class="form-error">{errors.HookNy?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-StepY">
            {t("ConnectorStepyi")}
          </label>
          <input
            class="form-input"
            id="grid-StepY"
            type="number"
            step={1}
            defaultValue={50}
            placeholder="iy [mm]"
            {...register("HookStepY", {
              required: t("Required"),
              min: {
                value: 0,
                message: t("Minimo") + " 0mm",
              },
              max: {
                value: 1000,
                message: t("Massimo") + " 1000mm",
              },
            })}
          />
          <p class="form-error">{errors.HookStepY?.message}</p>
        </div>
        <div class="form-col1_6"></div>

        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-X0">
            X0 [mm]
          </label>
          <input
            class="form-input"
            id="grid-beam-X0"
            type="number"
            step={1}
            defaultValue={100}
            placeholder="X0 [mm]"
            {...register("HookX0", {
              required: t("Required"),
              min: {
                value: 80,
                message: t("Minimo") + " 80mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p class="form-error">{errors.HookX0?.message}</p>
        </div>
        <div class="form-col1_6">
          <label class="form-label" for="grid-beam-Y0">
            Y0 [mm]
          </label>
          <input
            class="form-input"
            id="grid-beam-Y0"
            type="number"
            step={1}
            defaultValue={60}
            placeholder="Y0 [mm]"
            {...register("HookY0", {
              required: t("Required"),
              min: {
                value: 35,
                message: t("Minimo") + " 35mm",
              },
              max: {
                value: 10000,
                message: t("Massimo") + " 10m",
              },
            })}
          />
          <p class="form-error">{errors.HookY0?.message}</p>
        </div>
        <div class="form-col1_6"></div>
        <div class="form-col1_3"></div>
        <div class="form-col1_6"></div>

        <div class="form-col1_5 py-5 px-3">
          <button name="btn1" className="bg-green-700 text-white font-bold py-2 px-3 rounded" onClick={() => SetCreateReport(0)}>
            {t("Check")}
          </button>
          <button
            name="btn2"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-3 ml-3 rounded align-right"
            onClick={() => SetCreateReport(1)}
          >
            {t("Report")}
          </button>
        </div>
        <div class="form-col1_2 py-5">
        {
            (validData) ? ((Ratio > 1.0) ? (<p className="form-result" hidden={!validData}>{Ratio}</p>): (<p className="form-result-ok" hidden={!validData}>{Ratio}</p>)) : (<div/>)
          }
          {
            (Ratio > 1.0 || !validData) ? (<p className="form-result">{resultMessages}</p>): (<p className="form-result-ok">{resultMessages}</p>)
          }
        </div>
      </div>
    </form>
  );
}
